module.exports = __webpack_public_path__ + "media/images/front/post_no_image-f387b07c634af3a46a851bc23feeb90b.png";